var D = (a) => {
  throw TypeError(a);
};
var H = (a, e, t) => e.has(a) || D("Cannot " + t);
var r = (a, e, t) => (H(a, e, "read from private field"), t ? t.call(a) : e.get(a)), o = (a, e, t) => e.has(a) ? D("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(a) : e.set(a, t), l = (a, e, t, i) => (H(a, e, "write to private field"), i ? i.call(a, t) : e.set(a, t), t);
import { isElement as $, isHTMLElement as Y, parseHTMLFragment as K, isElementOrText as ae, focusNextElement as F, isFormInputElement as V, isFormOptionElement as W, isInputElement as ie, isLinkElement as se, dispatch as Q, groupBy as Z, nextAnimationFrame as J, wait as re, AbortError as ne, partition as ce, focusElement as oe, isFormElement as de } from "@coldwired/utils";
import ee from "morphdom";
var le = process.env.NODE_ENV === "production", P = "Invariant failed";
function B(a, e) {
  if (!a) {
    if (le)
      throw new Error(P);
    var t = typeof e == "function" ? e() : e, i = t ? "".concat(P, ": ").concat(t) : P;
    throw new Error(i);
  }
}
const he = [
  "role",
  "disabled",
  "hidden",
  "tab-index",
  "style",
  "aria-autocomplete",
  "aria-checked",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-label",
  "aria-level",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-placeholder",
  "aria-pressed",
  "aria-readonly",
  "aria-required",
  "aria-selected",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "aria-busy",
  "aria-live",
  "aria-relevant",
  "aria-atomic",
  "aria-dropeffect",
  "aria-grabbed",
  "aria-activedescendant",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-describedby",
  "aria-description",
  "aria-details",
  "aria-errormessage",
  "aria-flowto",
  "aria-labelledby",
  "aria-owns",
  "aria-posinset",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-setsize",
  "aria-atomic",
  "aria-busy",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-description",
  "aria-details",
  "aria-disabled",
  "aria-dropeffect",
  "aria-errormessage",
  "aria-flowto",
  "aria-grabbed",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-live",
  "aria-owns",
  "aria-relevant",
  "aria-roledescription"
];
var I, E, M;
class fe {
  constructor(e, t) {
    o(this, I);
    o(this, E);
    o(this, M);
    l(this, I, e), l(this, E, new MutationObserver((i) => {
      for (const s of i)
        this.onAttributeMutation(s);
    })), l(this, M, t);
  }
  observe() {
    r(this, E).observe(r(this, I), {
      attributes: !0,
      attributeFilter: he,
      subtree: !0
    });
  }
  disconnect() {
    r(this, E).disconnect();
  }
  onAttributeMutation(e) {
    if ($(e.target) && e.attributeName)
      if (e.attributeName == "style")
        Y(e.target) && r(this, M).attributeChanged(
          e.target,
          e.attributeName,
          e.target.style.cssText
        );
      else {
        const t = e.target.getAttribute(e.attributeName);
        r(this, M).attributeChanged(e.target, e.attributeName, t);
      }
  }
}
I = new WeakMap(), E = new WeakMap(), M = new WeakMap();
var O, z, S;
class ue {
  constructor(e, t) {
    o(this, O);
    o(this, z);
    o(this, S);
    l(this, O, e), l(this, z, new MutationObserver((i) => {
      for (const s of i)
        this.onAttributeMutation(s);
    })), l(this, S, t);
  }
  observe() {
    r(this, z).observe(r(this, O), {
      attributes: !0,
      attributeFilter: ["class"],
      attributeOldValue: !0,
      subtree: !0
    });
  }
  disconnect() {
    r(this, z).disconnect();
  }
  onAttributeMutation(e) {
    if ($(e.target))
      if (e.oldValue) {
        const t = new Set(e.oldValue.split(/\s/).filter(Boolean));
        r(this, S).classListChanged(e.target, t);
      } else
        r(this, S).classListChanged(e.target, /* @__PURE__ */ new Set([]));
  }
}
O = new WeakMap(), z = new WeakMap(), S = new WeakMap();
var _;
class be {
  constructor() {
    o(this, _, /* @__PURE__ */ new WeakMap());
  }
  get(e) {
    return r(this, _).get(e) ?? null;
  }
  getOrCreate(e) {
    let t = r(this, _).get(e);
    return t || (t = {
      addedClassNames: /* @__PURE__ */ new Set(),
      removedClassNames: /* @__PURE__ */ new Set(),
      touched: !1,
      attributes: {}
    }, r(this, _).set(e, t)), t;
  }
  clear() {
    l(this, _, /* @__PURE__ */ new WeakMap());
  }
}
_ = new WeakMap();
function pe(a, e, t) {
  var i;
  (i = t == null ? void 0 : t.plugins) == null || i.forEach((s) => {
    var n;
    return (n = s.validate) == null ? void 0 : n.call(s, a);
  }), a instanceof Document ? (B(e instanceof Document, "Cannot morph document to element"), ve(a, e, t)) : a instanceof Element && (B(!(e instanceof Document), "Cannot morph element to document"), e instanceof DocumentFragment ? G(a, e, t) : typeof e == "string" ? G(
    a,
    K(e, a.ownerDocument),
    t
  ) : k(a, e, t));
}
function G(a, e, t) {
  var i;
  if (e.normalize(), t != null && t.childrenOnly) {
    if (!((i = t == null ? void 0 : t.plugins) == null ? void 0 : i.some(
      (n) => {
        var c;
        return (c = n.onBeforeUpdateElement) == null ? void 0 : c.call(n, a, e);
      }
    ))) {
      const n = e.ownerDocument.createElement("div");
      n.append(e), k(a, n, t);
    }
  } else {
    const [s, n, ...c] = [...e.childNodes].filter(
      ae
    );
    $(s) ? (n && a.after(n), k(a, s, t)) : $(n) ? (a.before(s), k(a, n, t)) : (n && a.after(n), a.replaceWith(s)), a.after(...c);
  }
}
function k(a, e, t) {
  const i = t == null ? void 0 : t.forceAttribute;
  if (ee(a, e, {
    childrenOnly: t == null ? void 0 : t.childrenOnly,
    onBeforeElUpdated(s, n) {
      var R, U;
      if ((R = t == null ? void 0 : t.plugins) == null ? void 0 : R.some(
        (m) => {
          var L;
          return (L = m.onBeforeUpdateElement) == null ? void 0 : L.call(m, s, n);
        }
      ))
        return !1;
      const d = i ? !!n.closest(`[${i}="server"]`) : !1, w = (U = t == null ? void 0 : t.metadata) == null ? void 0 : U.get(s);
      if (d && w && (V(s) || W(s)) && (w.touched = !1), s.isEqualNode(n) || !d && i && !!s.closest(`[${i}="browser"]`))
        return !1;
      if (!d && w) {
        n.classList.add(...w.addedClassNames), n.classList.remove(...w.removedClassNames);
        for (const [m, L] of Object.entries(w.attributes))
          L == null ? n.removeAttribute(m) : m == "style" ? Y(n) && (n.style.cssText = L) : n.setAttribute(m, L);
        w.touched && (ie(s) && (s.type == "checkbox" || s.type == "radio") ? Object.assign(n, { checked: s.checked }) : W(s) ? Object.assign(n, { selected: s.selected }) : V(s) && Object.assign(n, { value: s.value }));
      }
      return !0;
    },
    onBeforeNodeDiscarded(s) {
      var n;
      return $(s) && ((n = t == null ? void 0 : t.plugins) == null || n.forEach((c) => {
        var d;
        return (d = c.onBeforeDestroyElement) == null ? void 0 : d.call(c, s);
      }), F(s, t)), !0;
    },
    onNodeAdded(s) {
      var n;
      return $(s) && ((n = t == null ? void 0 : t.plugins) == null || n.forEach((c) => {
        var d;
        return (d = c.onCreateElement) == null ? void 0 : d.call(c, s);
      })), s;
    }
  }), i) {
    const s = a.getAttribute(i) == "server" ? [a] : [];
    for (const n of [
      ...s,
      ...a.querySelectorAll(`[${i}="server"]`)
    ])
      n.removeAttribute(i);
  }
}
function ve(a, e, t) {
  e.head && Ae(a.head, a.adoptNode(e.head)), k(a.body, a.adoptNode(e.body), t);
}
function Ae(a, e) {
  ee(a, e, {
    childrenOnly: !0,
    onBeforeElUpdated(t, i) {
      return !t.isEqualNode(i);
    },
    onBeforeNodeDiscarded(t) {
      return !se(t);
    }
  });
}
const ye = {
  forceAttribute: "data-turbo-force",
  focusGroupAttribute: "data-turbo-focus-group",
  focusDirectionAttribute: "data-turbo-focus-direction",
  hiddenClassName: "hidden"
}, me = ["remove", "focus", "enable", "disable", "hide", "show", "reset"], ge = ["after", "before", "append", "prepend", "replace", "update"], Ce = [...me, ...ge];
var h, b, p, v, f, g, N, A, y, C, T;
class Oe {
  constructor(e) {
    o(this, h);
    o(this, b);
    o(this, p);
    o(this, v);
    o(this, f);
    o(this, g, new be());
    o(this, N, new AbortController());
    o(this, A, []);
    o(this, y, /* @__PURE__ */ new Set());
    o(this, C, /* @__PURE__ */ new Map());
    o(this, T);
    l(this, h, (e == null ? void 0 : e.element) ?? document.documentElement), l(this, b, { ...ye, ...e == null ? void 0 : e.schema }), l(this, T, (e == null ? void 0 : e.debug) ?? !1), l(this, A, (e == null ? void 0 : e.plugins) ?? []), l(this, f, {
      handleEvent: this.handleEvent.bind(this),
      classListChanged: this.classListChanged.bind(this),
      attributeChanged: this.attributeChanged.bind(this)
    }), l(this, p, new ue(r(this, h), r(this, f))), l(this, v, new fe(r(this, h), r(this, f)));
  }
  async ready() {
    const e = r(this, A).map((t) => t.ready());
    await Promise.all([...r(this, y), ...e]);
  }
  get element() {
    return r(this, h);
  }
  get plugins() {
    return r(this, A);
  }
  observe() {
    r(this, p).observe(), r(this, v).observe(), r(this, h).addEventListener("input", r(this, f)), r(this, h).addEventListener("change", r(this, f)), r(this, h).addEventListener(q, r(this, f)), r(this, A).forEach((e) => e.init(r(this, h)));
  }
  disconnect() {
    this.clear(), r(this, p).disconnect(), r(this, v).disconnect(), r(this, h).removeEventListener("input", r(this, f)), r(this, h).removeEventListener("change", r(this, f)), r(this, h).removeEventListener(q, r(this, f));
  }
  clear() {
    r(this, N).abort(), l(this, N, new AbortController()), r(this, y).clear(), r(this, C).clear(), r(this, g).clear();
  }
  applyActions(e) {
    const t = [], i = [];
    for (const c of e)
      xe(c) ? t.push(c) : i.push(c);
    this.scheduleMaterializedActions(t);
    const s = i.filter(Ne), n = Z(
      i.filter(Le),
      ({ delay: c }) => c
    );
    this.scheduleActions(s);
    for (const [c, d] of n)
      this.scheduleActions(d, c);
  }
  applyPinnedActions(e) {
    const t = [...r(this, C)].flatMap(([, i]) => i);
    this._applyActionsInContext(this.materializeActions(t, e));
  }
  after(e) {
    this.applyActions([{ action: "after", ...e }]);
  }
  before(e) {
    this.applyActions([{ action: "before", ...e }]);
  }
  append(e) {
    this.applyActions([{ action: "append", ...e }]);
  }
  prepend(e) {
    this.applyActions([{ action: "prepend", ...e }]);
  }
  replace(e) {
    this.applyActions([{ action: "replace", ...e }]);
  }
  update(e) {
    this.applyActions([{ action: "update", ...e }]);
  }
  remove(e) {
    this.applyActions([{ action: "remove", ...e }]);
  }
  focus(e) {
    this.applyActions([{ action: "focus", ...e }]);
  }
  disable(e) {
    this.applyActions([{ action: "disable", ...e }]);
  }
  enable(e) {
    this.applyActions([{ action: "enable", ...e }]);
  }
  hide(e) {
    this.applyActions([{ action: "hide", ...e }]);
  }
  show(e) {
    this.applyActions([{ action: "show", ...e }]);
  }
  reset(e) {
    this.applyActions([{ action: "reset", ...e }]);
  }
  morph(e, t, i) {
    r(this, p).disconnect(), r(this, v).disconnect(), this._morph(e, t, i), r(this, p).observe(), r(this, v).observe();
  }
  scheduleActions(e, t) {
    const i = this._scheduleActions(e, t);
    r(this, y).add(i), i.finally(() => r(this, y).delete(i));
  }
  scheduleMaterializedActions(e) {
    const t = J().then(() => this._applyActionsInContext(e));
    r(this, y).add(t), t.finally(() => r(this, y).delete(t));
  }
  materializeActions(e, t) {
    return this._debugMaterializeActions(e, t), e.map((i) => {
      const s = Ee(t, i.targets);
      return { ...i, targets: s };
    });
  }
  async _scheduleActions(e, t) {
    var i;
    if (!t)
      await J();
    else {
      try {
        await re(t, r(this, N).signal);
      } catch (s) {
        if (s instanceof ne) return;
        throw s;
      }
      if ((i = r(this, N).signal) != null && i.aborted) return;
    }
    for (const s of e)
      ze(s), this.pinAction(s);
    this._applyActionsInContext(this.materializeActions(e, r(this, h)));
  }
  _applyActionsInContext(e) {
    const [t, i] = ce(e, j);
    this._applyActions(i), t.length > 0 && (r(this, p).disconnect(), r(this, v).disconnect(), this._applyActions(t), r(this, p).observe(), r(this, v).observe());
  }
  _applyActions(e) {
    this._debugApplyActions(e);
    for (const t of e)
      j(t) ? this[`_${t.action}`](t) : (t.action != "focus" && t.targets.forEach((i) => {
        r(this, A).forEach((s) => {
          var n;
          return (n = s.validate) == null ? void 0 : n.call(s, i);
        });
      }), this[`_${t.action}`](t));
  }
  _debugMaterializeActions(e, t) {
    if (r(this, T) && e.length > 0) {
      e.length == 1 ? console.groupCollapsed("[actions] materialize one action:") : console.groupCollapsed(`[actions] materialize ${e.length} actions:`);
      for (const i of e)
        console.log(`"${i.action}"`, i.targets, t);
      console.groupEnd();
    }
  }
  _debugApplyActions(e) {
    if (r(this, T) && e.length > 0) {
      e.length == 1 ? console.groupCollapsed("[actions] apply one action:") : console.groupCollapsed(`[actions] apply ${e.length} actions:`);
      for (const t of e)
        console.dir(t);
      console.groupEnd();
    }
  }
  pinAction({ delay: e, pin: t, ...i }) {
    if (t && !e) {
      const s = `${i.action}--${i.targets}`;
      if (t == "last")
        r(this, C).set(s, [i]);
      else {
        let n = r(this, C).get(s);
        n || (n = [], r(this, C).set(s, n)), n.push(i);
      }
    }
  }
  _morph(e, t, i) {
    pe(e, t, {
      metadata: r(this, g),
      plugins: r(this, A),
      ...r(this, b),
      ...i
    });
  }
  _after({ targets: e, fragment: t }) {
    for (const i of e) {
      i.after(x(t, i));
      const s = i.parentElement;
      s && this.plugins.forEach((n) => {
        var c;
        return (c = n.onCreateElement) == null ? void 0 : c.call(n, s);
      });
    }
  }
  _before({ targets: e, fragment: t }) {
    for (const i of e) {
      i.before(x(t, i));
      const s = i.parentElement;
      s && this.plugins.forEach((n) => {
        var c;
        return (c = n.onCreateElement) == null ? void 0 : c.call(n, s);
      });
    }
  }
  _append({ targets: e, fragment: t }) {
    for (const i of e)
      i.append(x(t, i, !0)), this.plugins.forEach((s) => {
        var n;
        return (n = s.onCreateElement) == null ? void 0 : n.call(s, i);
      });
  }
  _prepend({
    targets: e,
    fragment: t
  }) {
    for (const i of e)
      i.prepend(x(t, i, !0)), this.plugins.forEach((s) => {
        var n;
        return (n = s.onCreateElement) == null ? void 0 : n.call(s, i);
      });
  }
  _replace({
    targets: e,
    fragment: t
  }) {
    for (const i of e)
      this._morph(i, x(t, i));
  }
  _update({ targets: e, fragment: t }) {
    for (const i of e)
      this._morph(i, x(t, i), {
        childrenOnly: !0
      });
  }
  _remove({ targets: e }) {
    for (const t of e)
      F(t, r(this, b)), t.remove();
  }
  _focus({ targets: e }) {
    const t = e.at(0);
    t && oe(t);
  }
  _show({ targets: e }) {
    for (const t of e)
      t.removeAttribute("hidden"), t.classList.remove(r(this, b).hiddenClassName);
  }
  _hide({ targets: e }) {
    for (const t of e)
      F(t, r(this, b)), t.setAttribute("hidden", "hidden"), t.classList.add(r(this, b).hiddenClassName);
  }
  _enable({ targets: e }) {
    for (const t of e)
      "disabled" in t && (t.disabled = !1);
  }
  _disable({ targets: e }) {
    for (const t of e)
      "disabled" in t && (F(t, r(this, b)), t.disabled = !0);
  }
  _reset({ targets: e }) {
    for (const t of e)
      de(t) ? t.reset() : console.warn("reset action is not supported on non-form elements", t);
  }
  handleEvent(e) {
    const t = e.composedPath && e.composedPath()[0] || e.target;
    if (e.type == q) {
      const i = (e.detail ?? []).map(
        (s) => ({
          ...s,
          targets: [t]
        })
      );
      this.applyActions(i);
    } else V(t) && (r(this, g).getOrCreate(t).touched = !0);
  }
  classListChanged(e, t) {
    const i = r(this, g).getOrCreate(e), s = new Set(e.classList), n = X(s, t), c = X(t, s);
    for (const d of n)
      i.addedClassNames.add(d), i.removedClassNames.delete(d);
    for (const d of c)
      i.removedClassNames.add(d), i.addedClassNames.delete(d);
  }
  attributeChanged(e, t, i) {
    r(this, g).getOrCreate(e).attributes[t] = i;
  }
}
h = new WeakMap(), b = new WeakMap(), p = new WeakMap(), v = new WeakMap(), f = new WeakMap(), g = new WeakMap(), N = new WeakMap(), A = new WeakMap(), y = new WeakMap(), C = new WeakMap(), T = new WeakMap();
function we(a, e) {
  for (const t of _e(a, e))
    t.remove();
}
function _e(a, e) {
  const t = a.flatMap((s) => [...s.children]).filter((s) => !!s.id), i = new Set(
    [...e.children].filter((s) => !!s.id).map((s) => s.id)
  );
  return t.filter((s) => i.has(s.id));
}
function X(a, e) {
  return new Set([...a].filter((t) => !e.has(t)));
}
function Fe(a) {
  return !!a && Ce.includes(a);
}
function Ne(a) {
  return !a.delay;
}
function Le(a) {
  return !!a.delay;
}
function j(a) {
  return "fragment" in a;
}
function xe(a) {
  return typeof a.targets != "string";
}
function Ee(a, e) {
  return e == "head" ? [a.ownerDocument.head] : e == "body" ? [a.ownerDocument.body] : [...a.querySelectorAll(e)];
}
function x(a, e, t = !1) {
  const i = typeof a == "string" ? K(a, e.ownerDocument) : a.cloneNode(!0);
  return t && we([e], i), i;
}
function Me(a) {
  if (j(a))
    return a.fragment instanceof DocumentFragment ? new XMLSerializer().serializeToString(a.fragment) : a.fragment;
}
function te(a) {
  return typeof a == "string" ? [...document.querySelectorAll(a)] : Array.isArray(a) ? [...a] : a ? [a] : [];
}
function ze(a) {
  B(!(a.delay && a.pin), "[actions] a delayed action cannot be pinned");
}
class Se extends HTMLElement {
  constructor() {
    super(), this.style.display = "none";
  }
  connectedCallback() {
    var n, c;
    const e = this.getAttribute("type"), t = ((n = this.parentElement) == null ? void 0 : n.tagName) == "HEAD" ? this.ownerDocument.documentElement : this.previousElementSibling;
    B(e, '[dispatch-event] must have "type" attribute'), B(t, "[dispatch-event] must have a target element");
    const i = (c = this.querySelector(
      'script[type="application/json"]'
    )) == null ? void 0 : c.textContent, s = i ? Te(i) : null;
    Q(e, { target: t, detail: s }), this.remove();
  }
}
customElements.get("dispatch-event") || customElements.define("dispatch-event", Se);
function Te(a) {
  const e = a.trim().replace(/^<!\[CDATA\[/, "").replace(/\]\]>$/, "").trim();
  if (!e) return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
const q = "__actions__";
function $e(a) {
  const e = Z(
    a.flatMap((t) => te(t.targets).filter((i) => i.isConnected).map((i) => [i, t.action, Me(t)])),
    ([t]) => t
  );
  for (const [t, i] of e)
    Q(q, {
      target: t,
      detail: i.map(([, s, n]) => ({ action: s, fragment: n }))
    });
}
function u({
  targets: a,
  ...e
}) {
  $e([{ ...e, targets: te(a) }]);
}
function qe(a) {
  u({ action: "hide", targets: a });
}
function Pe(a) {
  u({ action: "show", targets: a });
}
function Ve(a) {
  u({ action: "disable", targets: a });
}
function je(a) {
  u({ action: "enable", targets: a });
}
function Re(a) {
  u({ action: "remove", targets: a });
}
function Ue(a, e) {
  u({ action: "append", targets: a, fragment: e });
}
function De(a, e) {
  u({ action: "prepend", targets: a, fragment: e });
}
function He(a, e) {
  u({ action: "after", targets: a, fragment: e });
}
function We(a, e) {
  u({ action: "before", targets: a, fragment: e });
}
function Je(a, e) {
  u({ action: "update", targets: a, fragment: e });
}
function Ge(a, e) {
  u({ action: "replace", targets: a, fragment: e });
}
export {
  Oe as Actions,
  He as after,
  Ue as append,
  We as before,
  ye as defaultSchema,
  Ve as disable,
  u as dispatchAction,
  $e as dispatchActions,
  je as enable,
  qe as hide,
  Fe as isValidActionName,
  De as prepend,
  Re as remove,
  Ge as replace,
  Pe as show,
  Je as update
};
